import { FC } from 'react';

import { Head, Link } from '@inertiajs/react';

import { Routes } from '../../models/routes';

const sectionHeadingClassName = 'mt-6 mb-2 text-xl font-semibold';
const subpointClassName = 'mb-2';
const bulletListClassName = 'list-disc space-y-2 pl-6';

const Privacy: FC = () => (
    <>
        <Head title="Політика конфіденційності | CartOn" />
        <div className="container mx-auto max-w-5xl py-10">
            <div className="prose prose-sm max-w-none space-y-4 dark:prose-invert">
                <h1 className="mb-6 text-3xl font-bold">
                    ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ
                </h1>

                <h2 className={sectionHeadingClassName}>
                    1. ВИЗНАЧЕННЯ ТЕРМІНІВ
                </h2>

                <p>
                    Маркетплейс - сервіс розміщення оголошень з продажу
                    колекційних карток, що знаходиться за посиланням:{' '}
                    <a
                        href="https://www.carton.cards/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://www.carton.cards/
                    </a>
                    ;
                </p>
                <p>
                    Користувач - особа, що користується Маркетплейсом, в тому
                    числі, без зареєстрованого облікового запису;
                </p>
                <p>
                    Дані - персональні дані Користувачів, зібрані під час
                    взаємодії Користувача з Маркетплейсом, в тому числі, але не
                    виключно, прізвище, ім&apos;я та по батькові, дата та місце
                    народження, номери засобів зв&apos;язку, адреси електронної
                    пошти, відомості банківського рахунку, а також інші дані,
                    які дають можливість ідентифікувати Користувача;
                </p>
                <p>
                    Володілець Даних - фізична особа-підприємець Василишин Іван
                    Володимирович, запис в ЄДРЮОФОПГФ: 2001080000000006631 від
                    07.10.2020 року;
                </p>
                <p>
                    Політика - Політика конфіденційності, що регулює порядок
                    отримання, збору, накопичення, зберігання, зміну,
                    використання, поширення (передачу, обмін, розкриття),
                    знищення, забезпечення захисту та обробки Даних
                    Користувачів.
                </p>

                <h2 className={sectionHeadingClassName}>
                    2. ЗАГАЛЬНІ ПОЛОЖЕННЯ
                </h2>

                <p className={subpointClassName}>
                    2.1. Ця Політика розроблена фізичною особою-підприємцем
                    Василишин Іваном Володимировичем відповідно до чинного
                    законодавства України, в тому числі, але не виключно Закону
                    України «Про захист персональних даних», з урахуванням
                    принципів та правил Регламенту (ЄС) №2016/679 Європейського
                    Парламенту та Ради від 27.0.42016 року General Data
                    Protection Regulation (GDPR) щодо Користувачів Маркетплейсу
                    і встановлює порядок отримання, збору, накопичення,
                    зберігання, зміну, використання, поширення (передачу, обмін,
                    розкриття), знищення, забезпечення захисту та обробки Даних
                    Користувачів, у тому числі з використанням інформаційних
                    (автоматизованих) систем, що були зібрані з допомогою
                    Маркетплейсу.
                </p>
                <p className={subpointClassName}>
                    2.2. Моментом надання згоди Користувачем на обробку Даних є:
                </p>
                <ul className={bulletListClassName}>
                    <li>
                        реєстрація Користувачем облікового запису на
                        Маркетплейсі та/або авторизація такого облікового
                        запису;
                    </li>
                    <li>
                        внесення та збереження Користувачем у відповідному
                        розділі Користувачем Даних при налаштуванні власного
                        Облікового запису на Маркетплейсі та/або здійснення
                        будь-яких інших дій в межах Маркетплейсу (зокрема як
                        відвідувач сайту);
                    </li>
                    <li>
                        згода Користувача на збір та обробку персональних даних
                        шляхом проставлення відповідного знаку поряд з опцією
                        «Надаю згоду на збір та обробку персональних даних» при
                        реєстрації облікового запису на Маркетплейсі;
                    </li>
                    <li>
                        внесення Даних при оформленні замовлення на
                        Маркетплейсі.
                    </li>
                </ul>
                <p className={subpointClassName}>
                    2.3. Користувач, надаючи згоду на збір та обробку Даних,
                    погоджується з положеннями цієї Політики та надає Володільцю
                    Даних дозвіл на обробку власних Даних.
                </p>
                <p className={subpointClassName}>
                    2.4. Джерела збирання Даних:
                </p>
                <ul className={bulletListClassName}>
                    <li>
                        Користувачі можуть надавати Дані самостійно шляхом їх
                        розміщення на Маркетплейсі або повідомляючи засобами
                        телефонного зв&apos;язку та/або на електронну та/або
                        поштову адресу Володільця Даних, шляхом заповнення
                        опитувальників (заповнення анкети або в інший спосіб);
                    </li>
                    <li>
                        відгуки Користувачів (оцінка, коментарі, підтвердження
                        інформації);
                    </li>
                    <li>загальновідомі джерела.</li>
                </ul>

                <h2 className={sectionHeadingClassName}>
                    3. СКЛАД ДАНИХ, ЩО ОБРОБЛЯЮТЬСЯ
                </h2>

                <p className={subpointClassName}>
                    3.1. Під Даними розуміється будь-яка інформація, що прямо чи
                    опосередковано відноситься до конкретного Користувача та/або
                    яка надає можливість ідентифікувати конкретного Користувача.
                </p>
                <p className={subpointClassName}>
                    3.2. Володілець Даних може збирати наступні Дані:
                </p>
                <ul className={bulletListClassName}>
                    <li>
                        ім&apos;я, прізвище, по батькові (у разі наявності),
                        дата народження та/або вік, стать, інформація про рід
                        діяльності, сімейний стан, дані уповноваженої особи
                        компанії, найменування компанії, реквізити компанії,
                        контактні телефони, адреса електронної пошти, регіон
                        проживання, адреса місця проживання/перебування особи,
                        адреса місцезнаходження компанії, інші контакті дані за
                        бажанням Користувача (наприклад, місце та/або адреса
                        роботи), номери платіжних карток, токени платіжних карт;
                    </li>
                    <li>
                        інформація про обліковий запис Користувача зокрема
                        логін, номер телефону адреса електронної пошти, дані
                        процесингу облікового запису, інші Дані, необхідні для
                        здійснення обслуговування Користувачів Маркетплейсу,
                        комунікації з Користувачами в тому числі, в процесі
                        звернення Користувача до служби підтримки Маркетплейсу
                        та інша інформація, яка за бажанням Користувача
                        надається ним при заповненні Особистого кабінету
                        Користувача на Маркетплейсі;
                    </li>
                    <li>
                        інформація, яку Користувачі надають Володільцю Даних при
                        укладенні договорів про надання послуг шляхом акцепту
                        публічної оферти, розміщеної на Маркетплейсі;
                    </li>
                    <li>
                        інформація, яка необхідна для здійснення комунікації між
                        Користувачами Маркетплейсу в тому числі для здійснення і
                        підтвердження угод між продавцями та покупцями,
                        отримання і відправки повідомлень, розміщення відгуків,
                        коментарів, здійснення платежів, для виконання запитів
                        від Користувачів та отримання зворотного зв&apos;язку
                        від Користувача при необхідності, інформація, розміщена
                        Користувачами за результатами їх обслуговування,
                        відгуки, коментарі, звернення в службу підтримки
                        клієнтів, скарги, претензії, інші звернення;
                    </li>
                    <li>
                        дані про пристрої (комп&apos;ютер, тип браузера,
                        операційна система мобільного пристрою), що
                        використовуються Користувачами, інформація про веб-сайти
                        Користувачів такі як: ір-адреса; дата та час коли
                        Користувач користується Маркетплейсом, інформація про
                        програмне забезпечення, а також інтернет-браузер, що
                        використовувався Користувачем, інформація про операційну
                        систему мобільного пристрою, інформація про роботу
                        пристроїв Користувача, індивідуальні ідентифікатори
                        пристроїв, які використовують Користувачі;
                    </li>
                    <li>
                        інформація, отримана Володільцем Даних в результаті
                        здійснення маркетингової діяльності;
                    </li>
                    <li>
                        інформація про дії Користувача на Маркетплейсі (споживча
                        поведінка щодо придбаних товарів, робіт, послуг на
                        Маркетплейсі (історія переглядів, пошукові запити,
                        покупки, взаємодія з товарами) інформація щодо
                        спілкування з іншими Користувачами, в тому числі
                        інформація залишена Користувачами в чаті, формі
                        відгуків, виставлення оцінок, коментарів чи будь-який
                        інший зворотниАй зв&apos;язок від Користувачів;
                        інформація відповідно до якої формуються рейтинги
                        Користувачів, яка містить користувацький досвід і яку
                        Користувачі залишають на Маркетплейсі як результат
                        взаємодії з іншими Користувачами, що дозволяє Володільцю
                        Даних вжити необхідних заходів з метою підтримки
                        якісного обслуговування та уникнення шахрайських дій та
                        повідомлення (інформація, яка міститься в переписці між
                        Користувачами, а також в переписці з Володільцем
                        Даних/Адміністрацією Маркетплейса).
                    </li>
                </ul>
                <p className={subpointClassName}>
                    3.3. Володілець Даних не здійснює обробку спеціальної
                    категорії персональних даних (т.з. «чутливі дані»), які
                    стосуються расової, національної, етнічної приналежності,
                    політичних поглядів, релігійних та інших переконань,
                    членства в політичних партіях та/або організаціях,
                    інформацію, яка характеризує фізіологічні особливості
                    Користувачів.
                </p>
                <p className={subpointClassName}>
                    3.4. Володілець Даних може обробляти Дані за допомогою
                    наступних сервісів:
                </p>
                <ul className={bulletListClassName}>
                    <li>
                        файли Cookies - невеликий фрагмент Даних, які
                        пересилаються на комп&apos;ютер Користувача при переході
                        на веб-сторінку та/або при перегляді рекламного модуля
                        на веб-сторінці і зберігаються на комп&apos;ютері
                        Користувача та/або в його мобільному пристрої;
                    </li>
                    <li>
                        файли pixels - цифрові зображення, елемент матриці
                        дисплеїв, що формують зображення, які дозволяють
                        відслідкувати частоту використання Користувачем
                        веб-сторінки з метою визначення браузера Користувача і
                        надання сервісу, наприклад зберігання Даних в корзині
                        між відвідуваннями; а також з метою усунення помилок
                        роботи Маркетплейсу, ініційованих Користувачем при цьому
                        вся інформація обробляється у первісному вигляді і не
                        змінюється в процесі збору Даних.
                    </li>
                    <li>
                        PostHog - сервіс аналітики та відстеження помилок, який
                        використовується для покращення стабільності
                        Маркетплейсу.
                    </li>
                    <li>
                        Google AdSense - сервіс Google, який може
                        використовувати cookies та подібні технології для показу
                        реклами, (детальніше за посиланням:{' '}
                        <a
                            href="https://policies.google.com/technologies/ads"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://policies.google.com/technologies/ads
                        </a>
                        ).
                    </li>
                    <li>
                        Contentsquare - сервіс продуктової аналітики, який може
                        допомагати аналізувати взаємодію Користувачів із
                        Маркетплейсом.
                    </li>
                    <li>
                        Необов&apos;язкові аналітичні та рекламні сервіси
                        запускаються лише після згоди Користувача на
                        використання cookies.
                    </li>
                </ul>

                <h2 className={sectionHeadingClassName}>
                    4. МЕТА ОБРОБКИ ДАНИХ
                </h2>

                <p className={subpointClassName}>
                    4.1. Володілець даних здійснює збір та обробку Даних з
                    наступною метою:
                </p>
                <ul className={bulletListClassName}>
                    <li>
                        для ідентифікації клієнта як Користувача Маркетплейсу,
                        для зв&apos;язку з Користувачем в тому числі для надання
                        послуг, обробки платежів, відправки, проведення
                        розрахункових операцій, надання звітності, ведення
                        бухгалтерського та управлінського обліку, створення і
                        реалізації бонусних програм, програм лояльності,
                        відправки розсилок поштою, електронною поштою, за
                        номером телефону, в тому числі з метою відправки
                        комерційних пропозицій,
                    </li>
                    <li>
                        з метою забезпечення надання Володільцем Даних обміну
                        інформацією, створення профілю інтересів і надання
                        Користувачам у пошуковій видачі та за допомогою інших
                        технічних рішень, алгоритмів, доступних на Маркетплейсі,
                        найбільш релевантних товарів, пропозицій та контенту на
                        Маркетплейсі;
                    </li>
                </ul>

                <h2 className={sectionHeadingClassName}>
                    5. УМОВИ НАДАННЯ ДОСТУПУ ДО ДАНИХ
                </h2>

                <p className={subpointClassName}>
                    5.1. Розкриття Даних може відбуватись:
                </p>
                <ul className={bulletListClassName}>
                    <li>
                        працівникам Володільця Даних, які мають працювати з
                        такими Даними для виконання своїх трудових і
                        функціональних обов&apos;язків;
                    </li>
                    <li>
                        іншим Користувачам Маркетплейсу та їх ввіреним особам
                        при здійсненні замовлень в об&apos;ємі необхідному для
                        ідентифікації Покупця/Продавця та таких замовлень;
                    </li>
                    <li>
                        за обґрунтованими запитами органів державної влади,
                        інших уповноважених установ, які мають право витребувати
                        та отримувати такі Дані;
                    </li>
                    <li>
                        у випадку, якщо Володілець Даних має обґрунтовані
                        підозри щодо порушення Користувачем умов цієї Політики
                        та/або інших договорів та угод укладених між Володільцем
                        Даних та Користувачем, а також положень Публічного
                        договору.
                    </li>
                </ul>
                <p className={subpointClassName}>
                    5.2. В окремих випадках, з метою демонстрації ефективності
                    роботи Маркетплейсу, у маркетингових цілях, Володілець Даних
                    може розкривати статистику роботи Маркетплейсу, при цьому не
                    розкриваючи Дані та інформацію, що є комерційною таємницею.
                </p>
                <p className={subpointClassName}>
                    5.3. Маркетплейс надає можливості оформляти доставку
                    замовлень Покупців передаючи необхідну для цього інформацію
                    відповідним службам доставки.
                </p>
                <p className={subpointClassName}>
                    5.4. На Маркетплейсі можуть міститися посилання на інші
                    веб-ресурси, на які дія цієї Політики не розповсюджується.
                </p>
                <p className={subpointClassName}>
                    5.5. Володілець Даних здійснює обробку Даних на законній та
                    справедливій основі: Дані не розкриваються третім особам і
                    не розповсюджуються без згоди Користувача, за виключенням
                    випадків передбачених чинним законодавством України, лише в
                    інтересах національної безпеки, економічного добробуту і
                    прав людини.
                </p>
                <p className={subpointClassName}>
                    5.6. Володілець Даних залишає за собою право відповідно до
                    вимог чинного законодавства України здійснювати обмін Даними
                    з органами державної влади з метою: попередження шахрайства
                    на Маркетплейсі; врегулювання спірних ситуацій та
                    з&apos;ясування обставин, які є/можуть стати причиною
                    порушення законодавства, а також у випадку виявлення
                    Володільцем Даних неправомірних дій Користувачів
                    Маркетплейсу та/або отримання претензій, скарг, звернень
                    третіх осіб.
                </p>
                <p className={subpointClassName}>
                    5.7. Володілець Даних може здійснювати обмін Даними з
                    пов`язаними особами, партнерами.
                </p>
                <p className={subpointClassName}>
                    5.8. Дані Користувачів, які зберігаються на Маркетплейсі,
                    знаходяться в Україні. Користувач має право звернутись до
                    Володільця Даних щодо місцезнаходження власних Даних шляхом
                    направлення повідомлення на електронну адресу:
                    carton.market.ua@gmail.com або поштову адресу: 76005, м.
                    Івано-Франківськ, вул. Національної гвардії, буд. 3В, кв.
                    50.
                </p>

                <h2 className={sectionHeadingClassName}>
                    6. ПРАВА КОРИСТУВАЧІВ, ЯК СУБ&apos;ЄКТІВ ДАНИХ
                </h2>

                <p>
                    6.1. Відповідно до ч. 2 статті 8 Закону України «Про захист
                    персональних даних», Користувач має право:
                </p>

                <ul className={bulletListClassName}>
                    <li>
                        знати про джерела збирання, місцезнаходження своїх
                        Даних, мету їх обробки, місцезнаходження та/або місце
                        проживання (перебування) володільця чи розпорядника
                        Даних або дати відповідне доручення щодо отримання цієї
                        інформації уповноваженим ним особам, крім випадків,
                        встановлених Законом;
                    </li>
                    <li>
                        отримувати інформацію про умови надання доступу до
                        Даних, зокрема інформацію про третіх осіб, яким
                        передаються його Дані;
                    </li>
                    <li>на доступ до своїх Даних;</li>
                    <li>
                        отримувати не пізніш як за 30 (тридцять) календарних
                        днів з дня надходження запиту, крім випадків,
                        передбачених Законом, відповідь про те, чи зберігаються
                        його Дані, а також отримувати зміст його Даних;
                    </li>
                    <li>
                        пред&apos;являти вмотивовану вимогу володільцю Даних із
                        запереченням проти обробки своїх Даних;
                    </li>
                    <li>
                        пред&apos;являти вмотивовану вимогу щодо зміни або
                        знищення своїх Даних будь-яким володільцем та
                        розпорядником Даних, якщо ці Дані обробляються незаконно
                        чи є недостовірними;
                    </li>
                    <li>
                        на захист своїх Даних від незаконної обробки та
                        випадкової втрати, знищення, пошкодження у зв&apos;язку
                        з умисним приховуванням, ненаданням чи несвоєчасним їх
                        наданням, а також на захист від надання відомостей, що є
                        недостовірними чи ганьблять честь, гідність та ділову
                        репутацію фізичної особи;
                    </li>
                    <li>
                        звертатися зі скаргами на обробку своїх Даних до
                        Уповноваженого Верховної Ради України з прав людини або
                        до суду;
                    </li>
                    <li>
                        застосовувати засоби правового захисту в разі порушення
                        законодавства про захист Даних;
                    </li>
                    <li>
                        вносити застереження стосовно обмеження права на обробку
                        своїх Даних під час надання згоди (в тій частині в якій
                        це реалізовано);
                    </li>
                    <li>відкликати згоду на обробку Даних;</li>
                    <li>знати механізм автоматичної обробки Даних;</li>
                    <li>
                        на захист від автоматизованого рішення, яке має для
                        нього правові наслідки.
                    </li>
                </ul>

                <h2 className={sectionHeadingClassName}>
                    7. ЗМІНА ТА ВИДАЛЕННЯ ДАНИХ ВІДКЛИКАННЯ ЗГОДИ НА ОБРОБКУ
                    ДАНИХ
                </h2>

                <p className={subpointClassName}>
                    7.1. Користувач в будь-який момент має право
                    змінити/видалити Дані, відмовитися від розсилки повідомлень,
                    або відкликати згоду на обробку Даних шляхом направлення
                    повідомлення на електронну адресу:
                    carton.market.ua@gmail.com, або поштову адресу: 76005, м.
                    Івано-Франківськ, вул. Національної гвардії, буд. 3В, кв.
                    50.
                </p>
                <p className={subpointClassName}>
                    7.2. Після отримання такого повідомлення обробка Даних
                    Користувача буде припинена, а його Дані будуть видалені,
                    крім випадків, якщо така обробка може бути необхідна
                    відповідно до чинного законодавства України.
                </p>
                <p className={subpointClassName}>
                    7.3. Функціонування деяких можливостей Маркетплейсу для яких
                    необхідна інформація про Користувача, буде припинена з
                    моменту зміни/видалення Даних або обробки запиту на
                    відкликання згоди на обробку Даних.
                </p>
                <p className={subpointClassName}>
                    7.4. Володілець Даних здійснює обробку та зберігання Даних
                    для реалізації цілей, вказаних в цій Політиці протягом
                    всього необхідного періоду для цього, але не більше 5
                    (п&apos;яти) років з дати останньої взаємодії Користувача з
                    Маркетплейсом. В будь-якому випадку строки обробки та
                    зберігання Даних визначаються виходячи із цілей обробки
                    Даних, із врахуванням умов, вказаних в договорах, укладених
                    з Користувачами відповідно до вимог чинного законодавства
                    України.
                </p>
                <p className={subpointClassName}>
                    7.5. У випадку відсутності активності в Обліковому записі
                    Користувача протягом 1 (одного) року Володілець Даних має
                    право видалити такий кабінет, включаючи всі Дані, що
                    зберігаються в ньому.
                </p>

                <h2 className={sectionHeadingClassName}>
                    8. ПОРЯДОК РОБОТИ З ЗАПИТАМИ КОРИСТУВАЧІВ ЩОДО ДОСТУПУ ДО
                    ВЛАСНИХ ДАНИХ
                </h2>

                <p className={subpointClassName}>
                    8.1. Користувач має право на одержання відомостей про
                    обробку своїх Даних Володільцем Даних.
                </p>
                <p className={subpointClassName}>
                    8.2. Користувач подає запит щодо доступу (далі - «Запит») до
                    Даних, що зберігаються у Володільця Даних, шляхом
                    направлення повідомлення на електронну адресу:
                    carton.market.ua@gmail.com або поштову адресу: 76005, м.
                    Івано-Франківськ, вул. Національної гвардії, буд. 3В, кв.
                    50.
                </p>
                <p className={subpointClassName}>8.3. У Запиті зазначаються:</p>
                <ul className={bulletListClassName}>
                    <li>
                        прізвище, ім&apos;я та по батькові, місце проживання
                        (місце перебування) і реквізити документа, що посвідчує
                        особу Користувача;
                    </li>
                    <li>
                        відомості про Дані, стосовно яких подається Запит, а
                        саме перелік персональних даних, що запитуються;
                    </li>
                    <li>мета та/або правові підстави Запиту;</li>
                    <li>дата та підпис особи, яка звертається із Запитом.</li>
                </ul>
                <p className={subpointClassName}>
                    8.4. Володілець Даних розглядає Запит протягом 30 (тридцяти)
                    календарних днів з дня його надходження, якщо інше не
                    передбачено законом.
                </p>

                <h2 className={sectionHeadingClassName}>
                    9. ЗАХОДИ ЗАХИСТУ ДАНИХ
                </h2>

                <p className={subpointClassName}>
                    9.1. Володілець Даних, при обробці Даних застосовує всі
                    необхідні технічні, організаційні, правові заходи для
                    захисту Даних від неправомірного та/або несанкціонованого
                    доступу до таких Даних, в тому числі від змін, видалення,
                    надання, розповсюдження, а також інших неправомірних дій.
                </p>
                <p className={subpointClassName}>
                    9.2. Володілець Даних на постійній основі здійснює контроль
                    за прийнятими заходами щодо забезпечення безпеки.
                </p>
                <p className={subpointClassName}>
                    9.3. Організаційні заходи, вжиті Володільцем Даних,
                    охоплюють:
                </p>
                <ul className={bulletListClassName}>
                    <li>
                        контроль доступу працівників/уповноважених осіб
                        Володільця Даних до Даних Користувачів:
                    </li>
                    <li>
                        заходи для унеможливлення несанкціонованого доступу до
                        Даних Користувачів сторонніми особами.
                    </li>
                </ul>
                <p className={subpointClassName}>
                    9.4. Ведення обліку операцій, пов&apos;язаних з обробкою
                    Даних Користувачів та доступом до них: Володілець Даних
                    зберігає інформацію про дату, час та джерело надходження;
                    зміни; видалення або знищення Даних; ідентифікатор
                    працівника, який здійснив одну із вказаних операцій; При
                    здійсненні обробки Даних за допомогою програмного продукту
                    та/або автоматизованої системи такий продукт та/або система
                    автоматично фіксує вказану інформацію. У випадку здійснення
                    відповідних операцій із Даними у паперовому вигляді їх облік
                    здійснюється шляхом обліку дій та операцій (наприклад,
                    стосовно кадрових питань, господарських операцій тощо), в
                    рамках яких здійснюється відповідна обробка Даних, шляхом
                    оформлення документів, які зазвичай оформлюються у
                    Володільця Даних у зв&apos;язку з такими діями та
                    операціями.
                </p>
                <p className={subpointClassName}>
                    9.5. Технічні заходи захисту, вжиті Володільцем Даних,
                    охоплюють наступне: Володілець Даних використовує програмні
                    продукти, для обробки Даних які, мають вбудовані механізми
                    захисту інформації від несанкціонованого доступу для
                    забезпечення ідентифікації та автентифікації Користувачів,
                    цілісності електронних документів, реєстрації дій
                    Користувачів, управління доступом Користувачів до інформації
                    та окремих функцій. Підключення Користувачів до систем
                    Володільця Даних виконується з використанням протоколу
                    захищеного з&apos;єднання https. Системи Володільця Даних
                    мають вимоги до складності паролів, які створюють
                    Користувачі, щоб ускладнити спроби їх підбору. У деяких
                    випадках, наприклад, якщо Користувач виконав велику
                    кількість невдалих спроб авторизації, спрацьовує додатковий
                    алгоритм захисту від ботів шляхом відображення Користувачу
                    додаткового вікна для розпізнавання зображень в наборі
                    (reCAPTCHA).
                </p>
                <p className={subpointClassName}>
                    9.6. Володільцем Даних розроблено та впроваджено внутрішні
                    правила стосовно роботи з Даними. Володілець Даних на
                    постійній основі проводить аудит своїх систем безпеки з
                    метою виявлення можливостей для покращення безпечного
                    зберігання та використання даних Користувачів.
                </p>

                <h2 className={sectionHeadingClassName}>10. ДОДАТКОВІ УМОВИ</h2>

                <p className={subpointClassName}>
                    10.1. Володілець Даних має право змінити умови даної
                    Політики в будь-який момент. В такому випадку, оновлена
                    редакція буде розміщена на сторінці за посиланням:{' '}
                    <Link href={Routes.Privacy}>
                        https://www.carton.cards/privacy
                    </Link>
                    . Користувач не має право використовувати Маркетплейс, якщо
                    він не погоджується з умовами цієї Політики. У випадку, якщо
                    Користувач не погоджується зі змінами, він
                    зобов&apos;язується негайно припинити будь-яке користування
                    Маркетплейсом.
                </p>
                <p className={subpointClassName}>
                    10.2. Володілець Даних не несе відповідальності за шкоду або
                    збитки, яких зазнав Користувач або треті особи в результаті
                    помилкового розуміння або нерозуміння умов цієї Політики.
                    Користувач визнає, що у випадку його недбалого ставлення до
                    безпеки і захисту своїх Даних (в тому числі даних для
                    авторизації (пароль, логін) та пристроїв, які
                    використовуються для роботи із системами Володільця Даних,
                    треті особи можуть отримати несанкціонований доступ до
                    Особистого кабінету і Даних Користувача. Володілець Даних не
                    несе відповідальності за збитки, завдані таким Доступом.
                </p>
                <p className={subpointClassName}>
                    10.3. Володілець Даних не несе відповідальності за обробку
                    Даних, яка здійснюється Користувачами один щодо одного під
                    час взаємодії на Маркетплейсі. Кожен Користувач несе
                    особисту відповідальність за законність та безпеку обробки
                    Даних інших осіб, з якими він вступає у взаємодію,
                    включаючи, але не обмежуючись, збором, зберіганням,
                    передачею та використанням таких Даних. Користувачі
                    зобов&apos;язані самостійно забезпечити дотримання вимог
                    законодавства про захист персональних даних під час таких
                    взаємодій.
                </p>
                <p className={subpointClassName}>
                    10.4. У разі, якщо положення цієї Політики, пункти або їх
                    частини, будуть визнані такими, що суперечать діючому
                    законодавству України, або такими, що є недійсними, цей факт
                    ніяким чином не буде впливати на інші положення цієї
                    Політики, вони залишаються повністю чинні і продовжують
                    діяти повною мірою і є дійсними, а будь-яке інше недійсне
                    положення або положення, яке не може бути виконаним, без
                    подальших дій Сторін, вважається зміненим, виправленим в тій
                    мірі, в якій це необхідно для забезпечення його дійсності і
                    можливості виконання.
                </p>
                <p className={subpointClassName}>
                    10.5. У всьому іншому, що не передбачено/не визначено у цій
                    Політиці, Володілець Даних та Користувач (суб&apos;єкт
                    персональних даних) керуються нормами/вимогами Закону.
                </p>
            </div>
        </div>
    </>
);

export default Privacy;
